import { modalState } from '@/state/modal.state';
import { Modal as ModalComponent } from '@/ui/modal/modal';
import { useAtom } from 'jotai';
import { styled } from 'goober';
import { useTranslation } from 'react-i18next';
import { LoadCompaniesToProject } from '../projects/load-companies-to-project/load-companies-to-project';

export const LoadCompaniesToProjectModal = () => {
  const { t } = useTranslation('projects');
  const [modal, setModalState] = useAtom(modalState);

  if (modal?.state !== 'loadCompaniesToProject') return null;

  const close = () => {
    setModalState(null);
  };

  return (
    <Modal
      data-testid="load-companies-modal"
      header={t`loadCompanies`}
      onClose={close}
      variant="info"
    >
      <LoadCompaniesToProject projectId={modal.projectId} />
    </Modal>
  );
};

const Modal = styled(ModalComponent)`
  width: 560px;
  max-width: 95%;
`;
